import { render, staticRenderFns } from "./ViewAssessment.vue?vue&type=template&id=5528849e&scoped=true"
import script from "./ViewAssessment.vue?vue&type=script&lang=js"
export * from "./ViewAssessment.vue?vue&type=script&lang=js"
import style0 from "./ViewAssessment.vue?vue&type=style&index=0&id=5528849e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528849e",
  null
  
)

export default component.exports